'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkProductGroup } from '../../../types';
import { Grid, GridRow } from '../../components/Grid/grid';
import { Product } from '../Product/product';

export const ProductGroup: React.FC<LlmBlock<LlmChunkProductGroup>> = (props) => {
  const { item } = props;
  const classNames = getClassNames('llm__products');
  return (
    <div className={classNames}>
      <GridRow>
        {item.items.map((item, i) => (
          <Grid key={i} xs={6} sm={4} md={3}>
            <Product {...props} item={item} />
          </Grid>
        ))}
      </GridRow>
    </div>
  );
};

